import useSWR from "swr";
import type { AdminListData } from "../types/admin";
import { useCognitoOperations } from "./use-cognito";

interface UseAdminUsersReturn {
	users: AdminListData[];
	loading: boolean;
	error: Error | null;
	refetch: () => Promise<void>;
}

export const useAdminUsers = (): UseAdminUsersReturn => {
	const { listUsers } = useCognitoOperations();

	const { data, error, isLoading, mutate } = useSWR<AdminListData[]>("admin-users", listUsers, {
		revalidateOnFocus: false,
		revalidateOnReconnect: true,
	});

	const refetch = async () => {
		await mutate();
	};

	return {
		users: data || [],
		loading: isLoading,
		error: error || null,
		refetch,
	};
};
